/* eslint-disable no-unused-vars */
import { useCallback, useId, useMemo, useRef, memo } from 'react';
import {
  CustomInput,
  Label,
  CopyString,
  ToggleBtn,
  IconButton,
  DropDownWrapper,
  Each,
} from 'components';
import { formErrorsCampaign_action, creativesActions } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { LengthCounter } from '../index';
import { useSignal, useComputed } from '@preact/signals-react';
import * as S from './CtaTitle.styled';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { getCtaValueSelectedCreative } from 'store/selectors';
import { DropDownItem } from './DropDownItem';
import { ClearSearchInput } from 'assets/icons';

const MAX_SIZE = 25;

export const CtaTitle = memo(({ onChangeParam }) => {
  const reEngageGoal = useSelector(
    (state) => state.general.mainCampaignObject.currentCampaignObj.reEngageGoal,
  );
  const acquireNewUserGoal = useSelector(
    (state) => state.general.mainCampaignObject.currentCampaignObj.acquireNewUserGoal,
  );
  const ctaObj = useSelector(getCtaValueSelectedCreative);
  const { data } = manageCampaignsAPI.useGetBannerCtaListQuery(undefined, {
    selectFromResult: (response) => {
      const data = response?.data?.filter((item) => {
        if (reEngageGoal) {
          return item.cta_category_id === 2;
        } else if (acquireNewUserGoal) {
          return item.cta_category_id === 1;
        }
      });
      return { ...response, data };
    },
  });

  const dispatch = useDispatch();
  const btnRef = useRef(null);
  const inputId = useId();
  const dropDownId = useId();
  const ctaTitle = useSelector((state) => state.creatives.selectedCreative?.title);

  const dropDownIsOpen$ = useSignal(false);

  const dropDownValue = useMemo(() => {
    if (data) {
      return data.find(({ cta_type_id }) => cta_type_id === ctaObj.value);
    } else return null;
  }, [data, ctaObj.value]);

  const filteredData = useMemo(
    () => data?.filter(({ cta_type_id }) => cta_type_id !== ctaObj.value),
    [data, ctaObj.value],
  );

  const handleItemClick = useCallback(
    (itemId) => {
      dispatch(
        creativesActions.updateProperty({
          propField: ctaObj.field,
          newValue: itemId,
        }),
      );
      dropDownIsOpen$.value = false;
    },
    [dropDownIsOpen$.value],
  );

  const isError = useMemo(() => ctaTitle?.length < 2, [ctaTitle]);
  const maxCharsError = useMemo(() => ctaTitle?.length > MAX_SIZE, [ctaTitle]);

  const handleInputClick = useCallback(() => {
    dropDownIsOpen$.value = !dropDownIsOpen$.value;
  }, [dropDownIsOpen$.value]);

  const getErrorMsg = () => {
    if (maxCharsError) {
      return `Text exceeds the ${MAX_SIZE}-character limit. Please shorten your input and try again.`;
    }
    return 'Please Insert Title';
  };

  const handleClearTitle = useCallback(
    (e) => {
      e.stopPropagation();
      onChangeParam({ target: { value: '' } }, 'title');
    },
    [onChangeParam],
  );

  return (
    <S.Container>
      <S.InputBox ref={btnRef} style={{ position: 'relative' }}>
        <Label text='CTA:' variant='label' style={{ marginBottom: '8px' }} />
        <div onClick={handleInputClick}>
          <CustomInput
            width={172}
            value={dropDownValue?.cta_name || ''}
            autoComplete='off'
            id={dropDownId}
            name={dropDownId}
            isDropdown={true}
            arrowIconIsActive={dropDownIsOpen$.value}
            inputStyle={{
              minHeight: '48px',
            }}
            onChange={() => {}}
          />
        </div>
        {dropDownIsOpen$.value && (
          <DropDownWrapper
            isOpen$={dropDownIsOpen$}
            width={172}
            targetRef={btnRef}
            style={{
              top: '85px',
              left: '0px',
            }}
            outSideClickAction={() => {}}
          >
            <S.ListContainer>
              {
                <Each
                  fieldOfIndex='cta_type_id'
                  of={filteredData}
                  render={(item, index) => {
                    return <DropDownItem {...item} handleItemClick={handleItemClick} />;
                  }}
                />
              }
            </S.ListContainer>
          </DropDownWrapper>
        )}
      </S.InputBox>
      <S.InputBox>
        <S.LabelBox>
          <Label text='Title:' variant='label' />
          <LengthCounter maxSize={MAX_SIZE} str={ctaTitle} />
        </S.LabelBox>
        <CustomInput
          error={isError || maxCharsError}
          errorText={getErrorMsg()}
          placeholder='Title'
          onBlur={() => {}}
          value={ctaTitle}
          autoComplete='off'
          id={inputId}
          name={inputId}
          rightIcon={<ClearSearchInput />}
          rightIconOnClick={handleClearTitle}
          onChange={(e) => {
            onChangeParam(e, 'title');
            // onChangeParam(e, 'title', MAX_SIZE);
          }}
          inputStyle={{
            minHeight: '48px',
          }}
        />
      </S.InputBox>
    </S.Container>
  );
});

CtaTitle.displayName = 'CtaTitle';
